import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { GridApi } from '@mui/x-data-grid-pro'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'

import { SideDrawer } from '@sales-center/components'
import { useButtonActions } from './useButtonActions'
import { GridColumnsSelectorSlotProps } from './typings'
import { GridColumnsSelector } from './GridColumnsSelector'

import Button from '@mui/material/Button'

type Props = {
  apiRef: React.MutableRefObject<GridApi>
  disableInteraction: boolean
  hideDefaultBtn?: boolean
} & GridColumnsSelectorSlotProps

export const GridColumnsSelectorButton: React.FC<Props> = (props) => {
  const { apiRef, disableInteraction, ...rest } = props

  const { open, onOpen, onClose, columnCount } = useButtonActions(props)

  const theme = useTheme()

  return (
    <>
      <Button color="primary" onClick={onOpen} disabled={disableInteraction}>
        <ViewColumnIcon
          fontSize="small"
          style={{ marginRight: theme.spacing(0.5) }}
        />
        {`Columns (${columnCount})`}
      </Button>
      <SideDrawer
        title="Columns"
        open={open}
        onClose={onClose}
        width={700}
        overflow="hidden"
      >
        <GridColumnsSelector {...rest} apiRef={apiRef} onCancel={onClose} />
      </SideDrawer>
    </>
  )
}
